import { ServiceRoute, GLServiceBase } from "../../src/commonui/services/service";

class InvitationServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "admin/v1/invitationcodes", suffix: "{id}" };
	sendEmailUrl = "{id}/email/send";

	generateInvitationCode(params: any) {
		return this.create(params);
	}
	sendEmail(id, isFromCurriculum) {
		var query = `?isFromCurriculum=${isFromCurriculum}`;
		return this.create(this.sendEmailUrl + query, null, { id });
	}
}

export const InvitationService = new InvitationServiceClass();
